import { render, staticRenderFns } from "./CartItemCounter.vue?vue&type=template&id=fcfff29c&scoped=true&"
import script from "./CartItemCounter.vue?vue&type=script&lang=js&"
export * from "./CartItemCounter.vue?vue&type=script&lang=js&"
import style0 from "./CartItemCounter.vue?vue&type=style&index=0&id=fcfff29c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfff29c",
  null
  
)

export default component.exports